import mediator from "@tvg/mediator";

import { MediatorEventType, PromosPageData } from "./types";
import { track } from "../../../amplitude";
import { BaseEventProps } from "../../../types";
import { COMMON_EVENT_NAMES } from "../../../constants";

export default () => {
  mediator.base.subscribe(
    MediatorEventType.PAGEVIEW,
    (data: PromosPageData) => {
      track<BaseEventProps>(COMMON_EVENT_NAMES.PAGE_VIEWED, {
        [BaseEventProps.PROMO_SOURCE]: data.payload.promoSource
      });
    }
  );
};
